import { Typography, Button, Box } from "@mui/material"
import { useEffect, useRef, useState } from "react"
import { useContextState } from "../../../../../../../../../../hooks/theme"
import { icons } from "../../../../../../../../../../utils/icons"

interface Props {
    descriptionAnswer: string
}

const ExpandableText = ({ descriptionAnswer }: Props) => {
    const textRef = useRef<HTMLDivElement | null>(null)
    const [expanded, setExpanded] = useState(false)
    const [showButton, setShowButton] = useState(false)
    const { colors } = useContextState()

    useEffect(() => {
        if (textRef.current) {
            const isOverflowing =
                textRef.current.scrollHeight > textRef.current.clientHeight
            setShowButton(isOverflowing)
        }
    }, [descriptionAnswer])

    return (
        <Box>
            <Typography
                ref={textRef}
                sx={{
                    display: "-webkit-box",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: expanded ? "unset" : 1,
                    overflow: "hidden",
                    wordBreak: "break-word",
                }}
            >
                {descriptionAnswer}
            </Typography>

            {showButton && (
                <Button
                    sx={{
                        textDecoration: 'underline',
                        color: colors.color10,
                        fontSize: '12px',
                        '& .MuiSvgIcon-root': {
                            fontSize: '14px'
                        },
                        '&:hover': {
                            textDecoration: 'underline',
                        },
                        '&.MuiButton-root': {
                            padding: '0px',
                        }
                    }}
                    onClick={() => setExpanded((prev) => !prev)}
                >
                    {expanded ? "Ver menos" : "Ver más"} {expanded ? icons('view-less') : icons('view-more')}
                </Button>
            )}
        </Box>
    )
}

export default ExpandableText
